import { render, staticRenderFns } from "./AlertCardComponent.vue?vue&type=template&id=e0f0832c"
import script from "./AlertCardComponent.js?vue&type=script&lang=js&external"
export * from "./AlertCardComponent.js?vue&type=script&lang=js&external"
import style0 from "./AlertCardComponent.vue?vue&type=style&index=0&id=e0f0832c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports